import { getMatchedIngredients } from "./ingredients";
import { convertToGrams } from "@/features/units/conversion";

export function calculateNutrition(recipe) {
  let totalKcal = 0;
  let totalProtein = 0;
  let totalFat = 0;
  let totalCarbs = 0;
  let totalFiber = 0;
  let hasAnyNutrition = false;

  const matchedIngredients = getMatchedIngredients(recipe);
  if (matchedIngredients.length === 0) {
    return null;
  }

  matchedIngredients.forEach(ingredient => {
    const matchedIngredient = ingredient.closest_ingredients[0];
    const grams = convertToGrams(ingredient.amount, ingredient.unit, matchedIngredient);
    if (grams === 0) {
      return;
    }

    const factor = grams / 100;
    totalKcal += (matchedIngredient.kcal || 0) * factor;
    totalProtein += (matchedIngredient.protein || 0) * factor;
    totalFat += (matchedIngredient.fat || 0) * factor;
    totalCarbs += (matchedIngredient.carbs || 0) * factor;
    totalFiber += (matchedIngredient.fiber || 0) * factor;
    hasAnyNutrition = true;    
  });

  if (!hasAnyNutrition) {
    return null;
  }

  return {
    kcal: totalKcal,
    protein: totalProtein,
    fat: totalFat,
    carbs: totalCarbs,
    fiber: totalFiber,
  };
}

export function calculateNutritionPerIngredient(ingredients) {
  return ingredients.map(ingredient => {
    const matchedIngredient = ingredient.closest_ingredients[0];
    const grams = convertToGrams(ingredient.amount, ingredient.unit, matchedIngredient);
    if (grams === 0) {
      return null;
    }

    const factor = grams / 100;
    return {
      kcal: (matchedIngredient.kcal || 0) * factor,
      protein: (matchedIngredient.protein || 0) * factor,
      fat: (matchedIngredient.fat || 0) * factor,
      carbs: (matchedIngredient.carbs || 0) * factor,
      fiber: (matchedIngredient.fiber || 0) * factor,
    };
  });  
}

export function percentageColorCalories(percentage) {
  if (percentage > 60) {
    return 'danger';
  } else if (percentage > 40) {
    return 'warning';
  } else {
    return 'success';
  }
}

export function percentageColorMacro(percentage) {
  if (percentage < 10) {
    return 'danger';
  } else if (percentage < 20) {
    return 'warning';
  } else {
    return 'success';
  }
}

export function percentageColorCaloriesDaily(percentage) {
  if (percentage > 120) {
    return 'danger';
  } else if (percentage < 50) {
    return 'danger';
  } else if (percentage < 80) {
    return 'warning';
  } else {
    return 'success';
  }
}

export function percentageColorMacroDaily(percentage) {
  if (percentage > 120) {
    return 'danger';
  } else if (percentage < 50) {
    return 'danger';
  } else if (percentage < 80) {
    return 'warning';
  } else {
    return 'success';
  }
}
